import React from 'react'
import 'font-awesome/css/font-awesome.css'

const Icon: React.FC<{
  name?: string;
  fixedWidth?: boolean;
  spin?: boolean;
  className?: string;
}> = ({ name, fixedWidth, spin, className, ...props }) => {
  let _className = 'fa'
  if (name) _className += ' fa-' + name
  if (fixedWidth) _className += ' fa-fw'
  if (spin) _className += ' fa-spin'
  if (className) _className += ' ' + className

  return <i {...props} className={_className} />
}

export default Icon

